import { getDomainFromHref } from "./index";
import { browserHistory } from "react-router";

export const pushExternalLinkItem = (link_domain, link_text, link_url) => {
    const dataLayer = global.dataLayer;
    const obj = {
        event: 'click',
        content_type: 'link',
        link_domain,
        link_text,
        link_url,
        outbound: 'true'
    }
    if (dataLayer) {
        dataLayer.push(obj);
        //console.log('pushExternalLinkItem:', obj);
    }
}

export const pushMenuItem = (event, menu_name, menu_path = null) => {
    const target = event.currentTarget;
    const dataLayer = global.dataLayer;
    const isExternal =
        target.hostname && target.hostname !== window.location.hostname;

    const obj = {
        event: 'select_content',
        content_type: 'menu',
        menu_name,
    }

    obj.link_text = target.textContent.trim();
    obj.link_url = target.href;

    if (menu_path) {
        obj.menu_path = menu_path;
    }

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log('pushMenuItem:', obj);
    }

    if (target.target === '_blank' || isExternal) {
        pushExternalLinkItem(getDomainFromHref(obj.link_url), obj.link_text, obj.link_url)
    }
}

export const pushLinkItem = (input, content_type = 'link') => {
    const target =
        input && input.currentTarget
            ? input.currentTarget // event
            : input;              // element
    const dataLayer = global.dataLayer;
    const isExternal =
        target.hostname && target.hostname !== window.location.hostname;

    const obj = {
        event: 'select_content',
        content_type,
    };

    obj.link_text = target.textContent !== '' ? target.textContent.trim() : target.id;
    obj.link_url = target.href;

    if (target.target === '_blank' || isExternal) {
        pushExternalLinkItem(getDomainFromHref(obj.link_url), obj.link_text, obj.link_url)
    }

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log('pushLinkItem:', obj);
    }
};

export const pushCtaItem = (event, id = undefined) => {
    const target = event.currentTarget;
    const dataLayer = global.dataLayer;
    const isExternal =
        target.hostname && target.hostname !== window.location.hostname;

    const obj = {
        event: 'select_content',
        content_type: 'cta',
    }

    obj.link_text = target.textContent.trim() || undefined;
    obj.link_url = target.href ? target.href : undefined;
    obj.content_id = target.id || id;

    if (target.target === '_blank' || isExternal) {
        pushExternalLinkItem(getDomainFromHref(obj.link_url), obj.link_text, obj.link_url)
    }

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log('pushCtaItem:', obj);
    }
}

export const pushCardItem = (event) => {
    const target = event.currentTarget;
    const dataLayer = global.dataLayer;
    const isExternal =
        target.hostname && target.hostname !== window.location.hostname;

    const obj = {
        event: 'select_content',
        content_type: 'card',
    }

    const title = target.querySelector('.card-body > :first-child');
    const titleText = title ? title.textContent.trim() : undefined;
    const link = target.querySelector('.btn') || target.querySelector('.link-style');

    obj.link_text = link ? link.textContent.trim() : undefined
    obj.link_url = target.href ? target.href : undefined;
    obj.card_name = titleText ? titleText : target.id
        ? target.id : undefined;

    if (target.target === '_blank' || isExternal) {
        pushExternalLinkItem(getDomainFromHref(obj.link_url), obj.link_text || obj.card_name, obj.link_url)
    }

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log(`pushCardItem:`, obj);
    }
}

export const pushCardCtaItem = (event) => {
    event.stopPropagation();
    const target = event.currentTarget;
    const dataLayer = global.dataLayer;
    const isExternal =
        target.hostname && target.hostname !== window.location.hostname;

    const obj = {
        event: 'select_content',
        content_type: 'card_cta',
    }

    const title = target.closest('.card-body').querySelector('* > :first-child');
    const titleText = title ? title.textContent.trim() : undefined;

    const parentAnchor = target.closest('a');
    const parentUrl = parentAnchor ? parentAnchor.href : undefined;

    obj.link_text = target.textContent.trim() || undefined;
    obj.link_url = target.href ? target.href : parentUrl;
    obj.card_name = titleText ? titleText : target.id
        ? target.id : undefined;

    if (target.target === '_blank' || isExternal) {
        pushExternalLinkItem(getDomainFromHref(obj.link_url), obj.link_text, obj.link_url);
        window.location.href = obj.link_url;
    } else {
        browserHistory.push(obj.link_url);
    }

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log(`pushCardCtaItem:`, obj);
    }
}

export const pushSocialItem = (event) => {
    const target = event.currentTarget;
    const dataLayer = global.dataLayer;
    // const isExternal =
    //     target.hostname && target.hostname !== window.location.hostname;

    const obj = {
        event: 'select_content',
        content_type: 'social',
    }

    obj.link_text = target.textContent.trim() || undefined;
    obj.link_url = target.href || undefined;
    obj.link_domain = getDomainFromHref(target.href);
    obj.outbound = 'true'

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log('pushSocialItem:', obj);
    }
}

export const pushSearchResults = (term, count) => {
    const dataLayer = global.dataLayer;

    const obj = {
        event: 'search',
        content_type: 'search_results',
        search_term: term,
        search_results: count,
    }

    if (count > 0) {
        obj.success = 1;
    } else {
        obj.success = 0;
    }

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log('pushSearchResults:', obj);
    }
}

export const pushSearchResultsItem = (event, term) => {
    const target = event.currentTarget;
    const dataLayer = global.dataLayer;

    const obj = {
        event: 'select_content',
        content_type: 'search_results',
        search_term: term,
    }

    obj.link_text = target.textContent.trim() || undefined;
    obj.link_url = target.href || undefined;

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log('pushSearchResultsItem:', obj);
    }
}

/**
 * Pushes a form interaction event to the dataLayer.
 *
 * @param {'form_start' | 'form_progress' | 'form_error' | 'form_submit' | 'form_complete'} eventType -
 *   The type of form interaction event.
 *   - `"focus"` → user focuses on a field
 *   - `"input"` → user types or changes a field
 *   - `"submit"` → form submit attempt
 *   - `"error"` → validation or submission error
 * @param {string} name - The form’s name.
 * @param {string} id - The form’s ID.
 * @param {string|number} [step] - Optional step identifier.
 */
export const pushFormEvent = (eventType, name, id, step = undefined) => {
    const dataLayer = global.dataLayer;

    const obj = {
        event: eventType,
        content_type: 'form',
        form_name: name,
        form_id: id,
    };

    if (step) {
        obj.step = step;
    }

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log('pushFormEvent:', obj);
    }
};

export const buildEcomProductArrayForTopProducts = (products, category = undefined, listName = undefined) => {
    if (!products || !products.length) return;
    const items = [];
    products.forEach(product => {
        items.push({
            item_name: product.name || product.title,
            item_id: product.modelNumber || undefined,
            item_brand: 'Sentry Safe',
            item_category: category || undefined,
            item_category2: undefined,
            item_list_name: `Top Products > ${listName || category}`,
            item_variant: undefined,
            coupon: undefined,
            discount: undefined,
            'quantity': 1,
            price: product.priceBucket || undefined,
        })
    })
    return items;
}

// {
//     "name": "Fireproof and Waterproof Safe with Backlit Digital Keypad and Override Key",
//     "image": "//reviewcdn.masterlock.com/product/sentrysafe/FPW082HTC_SS_ECOM_01_hero.png",
//     "hoverImage": "//reviewcdn.masterlock.com/product/sentrysafe/FPW082HTC_SS_ECOM_02_lifestyle.png",
//     "modelNumber": "FPW082HTC",
//     "priceBucket": "$200-$400",
//     "discontinued": false,
//     "tile": false,
//     "bestOfBest": true,
//     "directToConsumer": "1",
//     "directToConsumerUrl": "https://store.sentrysafe.com/products/fpw082htc",
//     "ecommercePrice": "274.99",
//     "originalPrice": "0.00",
//     "onSale": false
// }

export const buildEcomProductArrayForPush = (products, category = undefined, category2 = undefined, listName = undefined) => {
    const items = [];
    let processedProducts;
    // console.log('products for object', products);

    if (products.length > 1) {
        // this is a collection and we need to weed out the promo cards
        processedProducts = products.filter(product => {
            return product.hasOwnProperty('originalPrice');
        })
    } else {
        // this is a single card click or a pdp
        processedProducts = products;
    }

    processedProducts.forEach(product => {
        const obj = {
            'item_name': product.name !== '' ? product.name : undefined,
            'item_id': product.modelNumber,
            'item_brand': 'Sentry Safe',
            'item_category': category,
            'item_category2': category2,
            'item_list_name': 'Product List',
            'item_variant': undefined,
            'coupon': undefined,
            'discount': undefined,
            'quantity': 1,
            'price': product.ecommercePrice ? product.ecommercePrice :
                product.originalPrice ? product.originalPrice : undefined,
        }
        items.push(obj);
    })

    return items;
}

export const buildPdpProductArrayForPush = (
    product,
    category = undefined,
    category2 = undefined,
    listName = undefined
) => {
    // console.log('products for pdp object', product);
    const items = [];
    const { ecommerceSalesPrice, ecommerceRegularPrice, couponCode, discountHeader, overView } = product;
    const price = ecommerceSalesPrice || ecommerceRegularPrice || undefined;

    items.push({
        item_name: overView.name !== '' ? overView.name : undefined,
        item_id: overView.modelNumber || undefined,
        item_brand: 'Sentry Safe',
        item_category: category,
        item_category2: category2,
        item_list_name: listName,
        item_variant: overView.size || undefined,
        coupon: couponCode || undefined,
        discount: discountHeader || undefined,
        'quantity': 1,
        price,
    });

    return items;
}

export const pushNewEcommerceEvent = (
    eventType,
    items,
    category = undefined,
    currency = 'USD',
    value = undefined
) => {
    const dataLayer = global.dataLayer;
    // console.log('items', items);

    const obj = {
        event: eventType,
        ecommerce: {
            items
        }
    };

    if (currency) {
        obj.currency = currency;
    }

    if (value) {
        obj.value = value;
    }

    if (dataLayer) {
        // clear previous ecommerce object before pushing new one
        dataLayer.push({ ecommerce: null });
        dataLayer.push(obj);
        //console.log('pushEcommerceEvent:', obj);
    }
};

/**
 * Pushes an e-commerce event into the global `dataLayer`.
 * Clears the previous `ecommerce` object before pushing a new one.
 *
 * @param {'view_item_list' | 'select_item' | 'view_item' | 'where_to_buy' | 'buy_now'} eventType
 *   The type of e-commerce event being tracked:
 *   - `"view_item_list"` → User viewed a list of products
 *   - `"select_item"` → User selected a product from a list
 *   - `"view_item"` → User viewed a single product detail
 *   - `"where_to_buy"` → User clicked "Where to Buy"
 *   - `"buy_now"` → User clicked "Buy Now"
 * @param {Array<Object>} products
 *   Array of product objects. Will be transformed by `buildEcomProductArrayForPush`.
 * @param {string} [category]
 *   Optional category label
 * @param {Object} [facets]
 *   Optional facets/filtering metadata (e.g., applied filters or categories).
 * @param {string} [currency]
 *   Optional ISO 4217 currency code (e.g., `"USD"`, `"EUR"`).
 *   If provided, it will be included in the event object.
 * @param {number} [value]
 *   Optional numeric value for the event (e.g., total price).
 *   Currently not added to the object unless you extend it.
 */
export const pushEcommerceEvent = (
    eventType,
    products,
    category = undefined,
    facets = undefined,
    currency = undefined,
    value = undefined
) => {
    const dataLayer = global.dataLayer;
    // console.log(products);

    const obj = {
        event: eventType,
        ecommerce: {
            items: undefined
        }
    };

    if (currency) {
        obj.currency = currency;
    }

    if (value) {
        obj.value = value;
    }

    if (products) {
        obj.ecommerce.items = buildEcomProductArrayForPush(products, category);
    }

    if (dataLayer) {
        // clear previous ecommerce object before pushing new one
        dataLayer.push({ ecommerce: null });
        dataLayer.push(obj);
        //console.log('pushEcommerceEvent:', obj);
    }
};

export const pushSortEvent = (event) => {
    const target = event.currentTarget;
    const dataLayer = global.dataLayer;

    const obj = {
        event: 'sort',
        content_type: 'product',
    }

    obj.sort_term = target[target.selectedIndex].textContent.trim() || undefined;

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log('pushSortEvent:', obj);
    }
}

export const pushFilterEvent = (event, group) => {
    const target = event.currentTarget;
    const dataLayer = global.dataLayer;

    const obj = {
        event: 'apply_filter',
        content_type: 'products',
    }

    const filterPath = `${group} > ${target.value}`;

    obj.filter_term = target.value || undefined;
    obj.filter_path = filterPath;

    if (dataLayer) {
        dataLayer.push(obj);
        //console.log('pushFilterEvent:', obj);
    }
}




// WEBPACK FOOTER //
// ./src/utils/datalayer.js